import './App.css';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

import useAuth from './components/useauth';
import SignIn from './components/signin/Signin';
import Dashboard from './pages/Maindashboard/Dashboard';
import { CompanyIdProvider } from './services/CompanyidProvider';
import FooterHelp from './components/FooterHelp/FooterHelp';
import GlobalFooter from './components/GlobalFooter/GlobalFooter';
import { BrowserRouter as Router } from 'react-router-dom';
import logger from './utils/logger';


const queryClient = new QueryClient()

function App() {

  const isAuthenticated = useAuth();
  if (isAuthenticated) {
    logger.log("isAuthenticated", isAuthenticated);
  }else {logger.debug("isAuthenticated", isAuthenticated);}
  
  if (!isAuthenticated) {
    return (<SignIn ></SignIn>)
  }
  else {
    return (
        <QueryClientProvider client={queryClient}>
          <Router>
            <CompanyIdProvider>
              <Dashboard />
              <FooterHelp id="dashboard" />
              <GlobalFooter />
              {/* <ReactQueryDevtools initialIsOpen={false} /> */}
            </CompanyIdProvider>
          </Router>
        </QueryClientProvider>
    );
  }
}

export default App;
